import { useEffect } from 'react';

import { usePostHog } from 'posthog-js/react';

import useEmailClient from '../features/email/hooks/useEmailClient';

import useAuth from './useAuth';

export default function usePosthogIdentify() {
  const { getClientInfo } = useEmailClient();

  const posthog = usePostHog();
  const { isAuthenticated, isLoading, broker, distribution } = useAuth();

  useEffect(() => {
    if (isLoading || !isAuthenticated || !broker || !distribution) return;

    const identify = async () => {
      const clientInfo = await getClientInfo();

      posthog.identify(broker.id, {
        email: broker.email,
        name: broker.name,
        distribution_id: distribution.id,
        broker_id: broker.id,
        crmBackend: broker.crm,
        theme: broker.theme,
        plan: broker.plan,
        appVersion: import.meta.env.VITE_APP_VERSION,
        clientInfo,
      });
    };

    identify();
  }, [
    broker,
    distribution,
    getClientInfo,
    isAuthenticated,
    isLoading,
    posthog,
  ]);
}
